import {useParams, useNavigate} from 'react-router-dom';
import {useQuery} from '@apollo/client';
import {useState} from 'react';
import {GET_MINI_FEEDBACK_BY_ID} from '../resolvers';
import {Spin, Tabs} from 'antd';
import {MiniFeedbackHeader} from './components/MiniFeedbackHeader';
import {MiniFeedbackStats} from './components/MiniFeedbackStats';
import {QuestionsTab} from './tabs/QuestionsTab';
import {ResponsesTab} from './tabs/ResponsesTab';
import styles from './singleMiniFeedback.module.scss';
import {ArrowLeftOutlined} from '@ant-design/icons';
import DBModal from 'components/modal/modal';
import {AddQuestionsForm} from './components/AddQuestionsForm';
import {NavTabsEnum} from 'utils/constants';
import {useSelector} from 'react-redux';
import {makeSelectTabOperations} from 'redux/store/auth';

export const SingleMiniFeedback = () => {
  const {featureId, id} = useParams();
  const navigate = useNavigate();
  const [openAddQuestion, setOpenAddQuestion] = useState(false);

  const tabOperations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.FAQ),
  );

  const {data, loading, error, refetch} = useQuery(GET_MINI_FEEDBACK_BY_ID, {
    variables: {
      input: {
        featureId,
        id,
      },
    },
    fetchPolicy: 'network-only',
  });

  const feedbackData = data?.getMiniFeedbackById?.data;

  if (loading) {
    return (
      <div className={styles.loading}>
        <Spin size="large" />
      </div>
    );
  }

  if (error || data?.getMiniFeedbackById?.__typename === 'Error') {
    return (
      <div className={styles.error}>
        <h2>{error?.message || data?.getMiniFeedbackById?.message}</h2>
      </div>
    );
  }

  if (!feedbackData) {
    return <div className={styles.error}>No data found.</div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.backBtn} onClick={() => navigate(-1)}>
        <ArrowLeftOutlined /> Back
      </div>
      <MiniFeedbackHeader
        title={feedbackData.title}
        isActive={feedbackData.isActive}
        description={feedbackData.description}
        onAddQuestion={() => setOpenAddQuestion(true)}
      />
      <MiniFeedbackStats
        totalResponses={feedbackData.totalResponses}
        clickThreshold={feedbackData.triggers?.clickThreshold}
        createdAt={feedbackData.createdAt}
      />
      <div className={styles.tabsContainer}>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="Questions" key="1">
            <QuestionsTab
              questions={feedbackData?.questions || []}
              feedbackId={id}
              featureId={featureId}
              baseLanguage={feedbackData?.language}
              refetch={refetch}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Responses" key="2">
            <ResponsesTab feedbackId={id} featureId={featureId} />
          </Tabs.TabPane>
        </Tabs>
      </div>
      {tabOperations?.create && (
        <DBModal
          isOpen={openAddQuestion}
          handleClose={() => setOpenAddQuestion(false)}
          width={900}
          content={
            <AddQuestionsForm
              feedbackId={id}
              baseLanguage={feedbackData?.language}
              closeModal={() => setOpenAddQuestion(false)}
              refetch={refetch}
            />
          }
        />
      )}
    </div>
  );
};
